import React from 'react';
import { useState, useEffect } from "react";
import axiosConfig from "../axiosConfig";
import Select from 'react-select';
import LineGraph from "../Graph/LineGraph";
import Header from '../Header/Header';
import MainMenu from '../MainMenu/MainMenu';
import axios from 'axios';
import * as XLSX from "xlsx";

const graphColors = [
    "#1f77b4",
    "#d62728",
    "#2ca02c",
    "#9467bd",
    "#ff7f0e",
    "#17becf",
    "#8c564b",
    "#e377c2",
    "#7f7f7f",
    "#bcbd22"
];

const DefinedChannelStatus = () => {

    const [update, setUpdate] = useState(0);
    const [time, setTime] = useState("15");
    const [type, setType] = useState("STB");
    const [channels, setchannels] = useState([]);
    const [selectedChannels, setSelectedChannels] = useState([]);
    const [rawChannelResponses, setRawChannelResponses] = useState([]);
    const [lastDate, setlastDate] = useState("");
    const [start, setstart] = useState("");
    const [finish, setfinish] = useState("");
    const [allchannelf, setallchannelf] = useState(false);

    const [label, setlabel] = useState([]);
    const [reach0, setReach0] = useState([]);
    const [reachp, setReachp] = useState([]);
    const [tvr0, setTvr0] = useState([]);
    const [tvrp, setTvrp] = useState([]);
    
    const [loading, setloading] = useState(false);

    useEffect(() => {
        axiosConfig.get("/trend/channels").then(rsp => {
            setchannels(rsp.data.channels || []);
        }).catch(err => {

        });
        axiosConfig.get("/daypart_date").then(rsp => {
            setlastDate(rsp.data.date);
        }).catch(err => {

        });
    }, []);

    const channelOptions = channels.map(channel => ({ label: channel.name, value: channel.id }));

    const handleChannelChange = (options) => {
        const selected = options || [];
        if(selected.length > 10){
            alert("You can select up to 10 channels");
            setSelectedChannels(selected.slice(0, 10));
            return;
        }
        setSelectedChannels(selected);
    };

    function isDateGreaterThan(date1, date2) {
        if (!date1 || !date2) return false;
        const [year1, month1, day1] = date1.split('-');
        const [year2, month2, day2] = date2.split('-');
      
        const dateObj1 = new Date(year1, month1 - 1, day1);
        const dateObj2 = new Date(year2, month2 - 1, day2);
      
        return dateObj1 > dateObj2;
    }

    const loadDayPartsData = () => {
        setloading(false);
        setUpdate(previousUpdate => previousUpdate + 1);

        const requests = selectedChannels.map((channel) => {
            const credentials = {
                "id": channel.value,
                "type": type,
                "range": time,
                "start": start,
                "finish": finish
            };
            return axiosConfig.post("/dayparts/all", credentials);
        });

        Promise.all(requests)
            .then(responses => {
                const buildDatasets = (key) => responses.map((rsp, index) => ({
                    label: selectedChannels[index].label,
                    data: rsp.data && rsp.data.value ? rsp.data.value[key] : [],
                    backgroundColor: graphColors[index % graphColors.length],
                    fill: false,
                    pointRadius: 1,
                    borderColor: graphColors[index % graphColors.length],
                    borderWidth: 3
                }));

                setReachp(buildDatasets("reachp"));
                setReach0(buildDatasets("reach0"));
                setTvr0(buildDatasets("tvr0"));
                setTvrp(buildDatasets("tvrp"));
                setlabel(responses[0] && responses[0].data && responses[0].data.value ? responses[0].data.value.label : []);
                setRawChannelResponses(responses.map(rsp => rsp.data));
                setloading(true);
            })
            .catch(err => {
                alert("Server Error");
                setUpdate(0);
                setloading(true);
            });
    };

    const updater = () => {
        if(selectedChannels.length === 0){
            alert("Please select at least one channel");
            return;
        }
        if(!time){
            alert("Please select a range");
            return;
        }
        if(!start || !finish){
            alert("Please select both start and finish dates");
            return;
        }
        if(isDateGreaterThan(start, finish)){
            alert("Start Date is greater than Finish Date");
            return;
        }
        if(lastDate && isDateGreaterThan(finish, lastDate)){
            alert("Finish Date is greater than last available date");
            return;
        }
        loadDayPartsData();
    };

    var datagenerate = (label, data, channel) => {
        var nlabel = ['Mid Point of Range'];
        channel.forEach((i) => { nlabel.push(i); });
        var alldata = [nlabel];
        for (var i = 0; i < label.length; i++) {
            var narr = [label[i]];
            for (var j = 0; j < channel.length; j++) {
                narr.push(data[j][i]);
            }
            alldata.push(narr);
        }
        return alldata;
    };

    const Downloadfunc = () => {
        if (!rawChannelResponses || rawChannelResponses.length === 0) {
            alert("No data available to download");
            return;
        }

        const wb = XLSX.utils.book_new();

        if (rawChannelResponses.length === 1) {
            const chData = rawChannelResponses[0];
            const chName = chData.channel || (selectedChannels[0] && selectedChannels[0].label) || "Channel";
            const val = chData.value || {};
            const sampleLive0 = val.label || label || [];
            const sampleLive = val.reach0 || [];
            const sampleLive1 = val.reachp || [];
            const sampleLive2 = val.tvr0 || [];
            const sampleLive3 = val.tvrp || [];

            const csv = [["Time-Frame", "Reach(000)", "Reach(%)", "TVR(000)", "TVR(%)"]];
            for (let i = 0; i < sampleLive.length; i++) {
                csv.push([sampleLive0[i], sampleLive[i], sampleLive1[i], sampleLive2[i], sampleLive3[i]]);
            }
            csv.push(["Start:", start]);
            csv.push(["Finish:", finish]);
            csv.push(["Range:", time]);
            csv.push(["Channel:", chName]);

            const ws = XLSX.utils.aoa_to_sheet(csv);
            XLSX.utils.book_append_sheet(wb, ws, "Day Parts");
            XLSX.writeFile(wb, "Day Parts " + chName + ".xlsx");
        } else {
            const nchannel = rawChannelResponses.map((res, index) => res.channel || (selectedChannels[index] && selectedChannels[index].label) || `Channel ${index + 1}`);
            const nreach0 = rawChannelResponses.map(res => (res.value && res.value.reach0) || []);
            const nreachp = rawChannelResponses.map(res => (res.value && res.value.reachp) || []);
            const ntvr0 = rawChannelResponses.map(res => (res.value && res.value.tvr0) || []);
            const ntvrp = rawChannelResponses.map(res => (res.value && res.value.tvrp) || []);
            const nlabel = (rawChannelResponses[0] && rawChannelResponses[0].value && rawChannelResponses[0].value.label) || label || [];

            const reach0data = datagenerate(nlabel, nreach0, nchannel);
            const reachpdata = datagenerate(nlabel, nreachp, nchannel);
            const tvr0data = datagenerate(nlabel, ntvr0, nchannel);
            const tvrpdata = datagenerate(nlabel, ntvrp, nchannel);
            const parameters = [['Start', 'End', 'Range']];
            parameters.push([start, finish, time]);

            const wsReach0 = XLSX.utils.aoa_to_sheet(reach0data);
            XLSX.utils.book_append_sheet(wb, wsReach0, 'Reach (000)');
            const wsReachp = XLSX.utils.aoa_to_sheet(reachpdata);
            XLSX.utils.book_append_sheet(wb, wsReachp, 'Reach (%)');
            const wsTvr0 = XLSX.utils.aoa_to_sheet(tvr0data);
            XLSX.utils.book_append_sheet(wb, wsTvr0, 'TVR (000)');
            const wsTvrp = XLSX.utils.aoa_to_sheet(tvrpdata);
            XLSX.utils.book_append_sheet(wb, wsTvrp, 'TVR (%)');
            const wsParams = XLSX.utils.aoa_to_sheet(parameters);
            XLSX.utils.book_append_sheet(wb, wsParams, 'Parameters');

            XLSX.writeFile(wb, "Day Parts Comparison.xlsx");
        }
    };

    const DownloadAll = () => {
        if(!start || !finish){
            alert("Please select both start and finish dates");
            return;
        }
        if(isDateGreaterThan(start, finish)){
            alert("Start Date is greater than Finish Date");
            return;
        }
        if(lastDate && isDateGreaterThan(finish, lastDate)){
            alert("Finish Date is greater than last available date");
            return;
        }

        var nchannel = [];
        var nreachp = [];
        var nreach0 = [];
        var ntvr0 = [];
        var ntvrp = [];
        var nlabel = [];
        setallchannelf(true);
        const wb = XLSX.utils.book_new();
        let axiosArray = [];

        channels.forEach((item) => {
            let postData = { "id": item.id, "type": type, "range": time, "start": start, "finish": finish };
            let newPromise = axiosConfig.post('/dayparts/all', postData);
            axiosArray.push(newPromise);
        });

        Promise
            .all(axiosArray)
            .then(axios.spread((...responses) => {
                responses.forEach((res) => {
                    nchannel.push(res.data.channel);
                    nreach0.push(res.data.value.reach0);
                    nreachp.push(res.data.value.reachp);
                    ntvr0.push(res.data.value.tvr0);
                    ntvrp.push(res.data.value.tvrp);
                    if (nlabel.length === 0) {
                        nlabel = res.data.value.label;
                    }
                });

                setallchannelf(false);
                var reach0data = datagenerate(nlabel, nreach0, nchannel);
                var reachpdata = datagenerate(nlabel, nreachp, nchannel);
                var tvr0data = datagenerate(nlabel, ntvr0, nchannel);
                var tvrpdata = datagenerate(nlabel, ntvrp, nchannel);
                var parameters = [['Start', 'End', 'Range']];
                parameters.push([start, finish, time]);

                var ws = XLSX.utils.aoa_to_sheet(reach0data);
                XLSX.utils.book_append_sheet(wb, ws, 'Reach (000)');
                var ws2 = XLSX.utils.aoa_to_sheet(reachpdata);
                XLSX.utils.book_append_sheet(wb, ws2, 'Reach (%)');
                var ws3 = XLSX.utils.aoa_to_sheet(tvr0data);
                XLSX.utils.book_append_sheet(wb, ws3, 'TVR (000)');
                var ws4 = XLSX.utils.aoa_to_sheet(tvrpdata);
                XLSX.utils.book_append_sheet(wb, ws4, 'TVR (%)');
                var ws5 = XLSX.utils.aoa_to_sheet(parameters);
                XLSX.utils.book_append_sheet(wb, ws5, 'Parameters');
                XLSX.writeFile(wb, "Day Parts All Channel.xlsx");
            }))
            .catch(error => {
                alert('Server Error');
                setallchannelf(false);
            });
    };

    return (
        <div>
            <Header title="Trend Analysis-Day Parts" />
            <MainMenu menu="trenddaypart" />

            <div class="app-content content" style={{ backgroundColor: "azure", minHeight: "36em" }}>
                <div class="content-overlay"></div>
                <div class="content-wrapper" style={{ backgroundColor: "azure" }} >
                    <div class="content-header row"></div>
                    <div class="content-body">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <Select
                                                placeholder="Select channels (up to 10)"
                                                isMulti
                                                closeMenuOnSelect={false}
                                                options={channelOptions}
                                                value={selectedChannels}
                                                onChange={handleChannelChange}
                                                isOptionDisabled={(option) => selectedChannels.length >= 10 && !selectedChannels.some(channel => channel.value === option.value)}
                                            />
                                        </div>
                                        <div class="col-md-2">
                                            <select class="custom-select d-block w-100" id="range" required="" value={time} onChange={(e) => { setTime(e.target.value) }}>
                                                <option value="5">5 Minutes</option>
                                                <option value="15">15 Minutes</option>
                                                <option value="30">30 Minutes</option>
                                            </select>
                                        </div>

                                        <div class="col-md-5">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <fieldset class="form-group form-group-style">
                                                        <label for="start">Start Date</label>
                                                        <input type="date" class="form-control" id="start" max={lastDate} onChange={(e) => { setstart(e.target.value) }} />
                                                    </fieldset>
                                                </div>
                                                <div class="col-md-6">
                                                    <fieldset class="form-group form-group-style">
                                                        <label for="finish">Finish Date</label>
                                                        <input type="date" class="form-control" id="finish" max={lastDate} onChange={(e) => { setfinish(e.target.value) }} />
                                                    </fieldset>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-1">
                                            <button onClick={updater} class="btn btn-info">View</button>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">
                                            <label>Type (STB/OTT)</label>
                                            <select class="custom-select d-block w-100" disabled onChange={(e) => { setType(e.target.value)}}>
                                                <option value="STB">STB</option>
                                                <option value="">All</option>
                                                <option value="OTT">OTT</option>
                                            </select>
                                        </div>

                                        <div class="col-md-2"></div>
                                        <div class="col-md-3">
                                            {(() => {
                                                if (allchannelf) {
                                                    return (
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <img src="https://upload.wikimedia.org/wikipedia/commons/c/c7/Loading_2.gif?20170503175831" style={{height:"5em",width:"5em"}} class="rounded mx-auto d-block" alt="..." />
                                                            </div>
                                                            <div class="col-md-8"> Please Wait Some Minutes</div>
                                                        </div>
                                                    );
                                                } else {
                                                    return null;
                                                }
                                            })()}
                                        </div>
                                        <div class="col-md-3">
                                            <label>Download (All Channel)</label><br/>
                                            <button onClick={DownloadAll} class="btn btn-danger">Download CSV</button>
                                        </div>
                                        {(() => {
                                            if (loading) {
                                                return (
                                                    <div class="col-md-2">
                                                        <label>Download Data</label><br/>
                                                        <button onClick={Downloadfunc} class="btn btn-danger">Download CSV</button>
                                                    </div>
                                                );
                                            } else {
                                                return null;
                                            }
                                        })()}
                                    </div>
                                    <div class="row">
                                        {(() => {
                                            if (lastDate) {
                                                return (<div><br/> <h6>Data available upto {lastDate}</h6></div>);
                                            } else {
                                                return null;
                                            }
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />

                        <div class="row">
                            <div class="col-md-6">
                                <LineGraph title="Reach (%)" text="Active Channels" loading={loading} labels={label} datasets={reachp} color="blue" update={update} />
                            </div>
                            <div class="col-md-6">
                                <LineGraph title="Reach (000)" text="Active Channels" loading={loading} labels={label} datasets={reach0} color="red" update={update} />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <LineGraph title="TVR (000)" text="Active Channels" loading={loading} labels={label} datasets={tvr0} color="violet" update={update} />
                            </div>
                            <div class="col-md-6">
                                <LineGraph title="TVR (%)" text="Active Channels" loading={loading} labels={label} datasets={tvrp} color="green" update={update} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DefinedChannelStatus;